// extracted by mini-css-extract-plugin
export var modal = "_5i-0";